<template>
  <div :class="{'swipers':true,'jinriswiperRight1':swiperR,'jinriswiperDown1':swiperD,'jinriswiperLeft':swiperL}">
    <div class="thumbs swiper-container"
         :id="Top"
         ref="centerEle"
         :class="{'jinriswiperRight2':swiperR,'jinriswiperDown2':swiperD}">
      <ul
          class="clearfix swiper-wrapper">
          <li class="fl swiper-slide"
              @contextmenu.stop.prevent="$emit('windowRightMenu',$event,0,integrationData,integrationData)"
              @click="$emit('rightFalse')">
            <jinriShow :content="integrationData" :placeholderImage="placeholderImage" :demonstrations="demonstrations"  ></jinriShow>
          </li>
      </ul>
    </div>
    <div :class="{'jinriswiperRight3':swiperR,'jinriswiperDown3':swiperD}"></div>
    <div class="jinriswiperDown"
         :class="{'jinriswiperRight4':swiperR,'jinriswiperDown4':swiperD}">
      <div class="detail-contents swiper-container"
           :id="Down"
           :style="{'height':heights+'px'}"
           :class="{'jinriswiperRight5':swiperR,'jinriswiperDown5':swiperD}">
        <ul
            class="clearfix swiper-wrapper">
          <template v-for="(ite,ind) in integrationSwiperData">
            <li :class="['fl', 'swiper-slide',{'swiper-slide-active':ind == chooseInd}]"
                @contextmenu.stop.prevent="$emit('windowRightMenu',$event,0,integrationData,integrationData)"
                :key="ind" @click="changeData(ite,ind)">
              <span class="mainTitle">{{ ite.contentName }}</span>
            </li>
          </template>
        </ul>
      </div>
      <div class='arrow-right' @click="goToSerialize"
           :class="{'jinriswiperRight':swiperR,'jinriswiperDown':swiperD}"></div>
    </div>
  </div>
</template>
<script>
import ZImage from "../ZImage.vue"
import jinriShow from "../../components/floorBlock/jinriShowContent.vue"
import Bus from '../../bus.js'
export default {
  name: 'jinrizixunSwipers',
  components: {
    ZImage,
    jinriShow
  },
  props: {
    sortTag: {
      type: Array,
      default: []
    },
    ind: String,
    Name: Array,
    slideIndex:Number,
    demonstrations:{
      type:String
    }
  },
  data () {
    return {
      heights:'',
      swiperR: '',
      swiperL: '',
      swiperD: 'true',
      direction: 'horizontal',
      integrationData:this.sortTag[0],
      integrationSwiperData:[],
      chooseInd:0,
      haveData:false,
      placeholderImage:''
    }
  },
  filters:{
    toSelect(ite){
      return ite.filter((tags) => tags.standardEnName == 'appName' && tags.standardData)[0].standardData
    }
  },
  created(){
      this.getSwiperData()
  },
  mounted () {
    this.getSwiperDir(this.ind);
    var _this = this;
    //监听中间块高度
    var elementResizeDetectorMaker = require("element-resize-detector")
    var erd = elementResizeDetectorMaker();
    //监听中心展示高度
    erd.listenTo(_this.$refs.centerEle, function (element) {
      if(_this.direction == 'vertical'){
        _this.heights = element.clientHeight;
      }
    })
    
    Bus.$on('swiper', (t) => {
      if (t == _this.ind) {
        _this.getSwiperDir(_this.ind);
      }
    });
  },
  computed: {
    Top () {
      return 'Top' + this.ind;
    },
    Down () {
      return 'Down' + this.ind;
    }
  },
  methods: {
    goToSerialize(){
      if(this.haveData){
        this.open( location.origin + '/uoqid/odzid/chat?isMedia=1&brush=2&isTop=true&pfId='+ window.$pfId +'&serialize=' + this.$contentId, '_blank')
      }
      // this.routerJump('replace','odzid/chat',{isMedia:1,brush:2,isTop:true,serialize:this.$contentId,pfId:window.$pfId});
    },
    changeData(ite,ind){
      this.chooseInd = ind
      this.$http.get("/zciid-deliverable/showPlatformStyle/flow/api/getWzSerializeBycontentId.json", {
        contentId:ite.contentId
      }).then(res => {
        if(res.state == 1 ){
          this.integrationData = res.data.standardJson

          if(res.data.sign == 2){
            //抖变世界类型做特殊处理
            var pictures = [],
                others = [],
                pcVideo = '',
                mobileVideo = '',
                ele = res.data.standardJson
                //判断是否有视频
                var videoL = ele.filter((tag) => tag.standardEnName == 'videoShow' && tag.standardData && !this.isPic(tag.standardData)).length
                
                ele.forEach((item) => {
                  if (item.standardEnName == 'VideoCover' && item.standardData) {
                    //视频封面
                    this.placeholderImage = item.standardData
                    
                  }
                  //有视频图片不显示
                  if ((this.isPic(item.standardData) && !videoL) || this.isVideo(item.standardData)) {
                    if (item.standardEnName == 'videoShow' || item.standardEnName == 'VideoCover') {
                      pcVideo = item
                    }
                    if (item.standardEnName == 'subVideo1') {
                      mobileVideo = item
                    }
                    if (this.IsMobile()) {
                      if (mobileVideo) {
                        pictures.push(mobileVideo)
                      } else {
                        pictures.push(pcVideo)
                      }
                    } else {
                      pictures.push(pcVideo)
                    }
                  } else if (!this.isPic(item.standardData)) {
                    others.push(item)
                  }
                })
                this.integrationData = [...pictures,...others]
                
          }
        }
      }).then(()=>{
        document.querySelector('.slideshow').scrollIntoView({ behavior: 'smooth' })
      })
    },
    getSwiperData(){
      let data = this.sortTag[0].filter((tags) => tags.standardEnName == 'appName' && tags.standardData)
      let arr = [{contentId:data[0].contentId || this.$contentId,contentName:data[0].standardData}]
      this.integrationSwiperData = arr
      if(!this.getQuery('childContentId')){
        //获取下侧轮播图内容，并整合大接口数据
        this.$http.get("/zciid-deliverable/api/issue/getBindingList.json", {
          pId: data[0].contentId || this.$contentId
        }).then(res => {
          if(res.state == 1 && res.data.length){
            this.haveData = true
            this.integrationSwiperData = [...arr,...res.data]
          }
        })
      }
    },
    touchstarts (ev, ind, ite) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.$emit('emitContextMenuItem', ev, ind, ite);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchstarts (ev, ind, ite) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.handleContextmenu(ev, ind, ite);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmove: function () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchend: function (e) {
      clearTimeout(this.timeOutEvent);
      return false;
    },
    swiperFn () {
      var _this = this;
      var mySwiper,thumbSwiper;
      thumbSwiper = new Swiper('#Down' + _this.ind, {
        // paginationClickable: true,
        //解决初始化轮播不生效
        observer: true,
        observeParents: true,
        slidesPerView: window.innerWidth < 768 ? 2 : 5,
        direction: this.direction,
        spaceBetween: 20,
        watchSlidesVisibility: true,//防止不可点击
      })
      // mySwiper = new Swiper('#Top' + this.ind, {
      //   slidesPerView: 1,
      //   observer: true,
      //   observeParents: true,
      //   initialSlide:this.slideIndex,
      //   autoHeight: true,
      //   thumbs:{
      //     swiper: thumbSwiper
      //   },
      //   on: {
      //     slideChangeTransitionEnd: function(){
      //       _this.$emit('changeText',this.activeIndex);
      //     },
      //     // init: function(){
      //     //   setTimeout(()=>{
      //     //     var index = _this.matching(_this.sortTag);
      //     //     this.slideTo(index,0);
      //     //     window.$contentIndex = index;
      //     //   },10)
      //     // }
      //   }
      // })
    },
    //寻找参数
    getQuery (name) {
      // 正则：[找寻'&' + 'url参数名字' = '值' + '&']（'&'可以不存在）
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);//substr() 的参数指定的是子串的开始位置和长度
      if (r != null) {
        // 对参数值进行解码
        return decodeURI(r[2]);
      }
      return null;
    },
    //获取轮播图方向
    getSwiperDir (num) {
      var _this = this;
      _this.$http.get("/zciid-deliverable/showPlatformStyle/flow/api/detail/getTappByBlockId.json", {
        appId: this.$appId,
        blockId: this.getQuery('blockId'),
        sign: num
      }).then(res => {
        if (res.state == 1) {
          if (res.data.left == '1') {
            _this.swiperL = true;
            _this.swiperR = true;
            _this.swiperD = false;
            _this.direction = 'vertical';
          } else if (res.data.left == '2') {
            _this.swiperL = false;
            _this.swiperR = false;
            _this.swiperD = true;
            _this.direction = 'horizontal';
          } else if (res.data.left == '3') {
            _this.swiperL = false;
            _this.swiperR = true;
            _this.swiperD = false;
            _this.direction = 'vertical';
          }
        }
      }).then(() => {
        _this.$nextTick(() => {
          // _this.swiperFn();
        })
      })
    },
  }
}
</script>
<style scoped>
.jinriswiperLeft {
  flex-direction: row-reverse;
}
.jinriswiperRight1 {
  width: 100%;
  height: 100%;
  display: flex;
}
.jinriswiperDown1 {
  width: 100% !important;
  height: 100% !important;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.jinriswiperRight2 {
  width: calc(100% - 73px);
  width: -moz-calc(100% - 73px);
  width: -webkit-calc(100% - 73px);
  width: -o-calc(100% - 73px);
  width: -ms-calc(100% - 73px);
  height: 100%;
}
.jinriswiperDown2 {
  width: 100%;
  height: calc(100% - 73px);
  height: -moz-calc(100% - 73px);
  height: -webkit-calc(100% - 73px);
  height: -o-calc(100% - 73px);
  height: -ms-calc(100% - 73px);
}
.jinriswiperRight3 {
  width: 15px;
  height: 100%;
}
.jinriswiperDown3 {
  width: 100%;
  height: 10px;
}
.jinriswiperRight4 {
  display: flex;
  align-items: center;
  height: 100%;
  width: 54px;
}
.jinriswiperDown4 {
  display: flex;
  align-items: center;
  width: 100%;
}
.jinriswiperRight5 {
  height: 100%;
}
.jinriswiperDown5 {
  width: 100%;
}
.detail-contents.swiper-container.jinriswiperRight5 li {
  width: 50px !important;
  /* background-color: #ededed; */
}
.detail-contents.swiper-container.jinriswiperDown5 li {
  height: 50px;
  width: calc(20% - 8px);
  cursor: pointer;
  /* background-color: #ededed; */
  border: 1px solid #ddd;
  margin-right: 10px;
  box-sizing: border-box;
}
@media screen and (max-width: 768px){
  .detail-contents.swiper-container.jinriswiperDown5 li {
    width : calc(50% - 5px) !important;
  }
}
.thumbs{
  min-height: 200px;
}
/* .thumbs.swiper-container li {
  background-color: #ededed;
} */
.detail-contents.swiper-container li.swiper-slide-active {
  border: 2px solid red;
}
.detail-contents .swiper-wrapper {
  height: 100%;
  position: relative;
}
.jinriswiperDown {
  position: relative;
}
.jinriswiperDown li{
  overflow: hidden;
}
.jinriswiperDown .arrow-left.jinriswiperRight {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 0;
  left: 30%;
  margin-top: -13px;
  transform: rotate(90deg);
  background: url("~@/assets/images/product_detail/recommend_arrow_left.png")
    no-repeat center;
  cursor: pointer;
}
.jinriswiperDown .arrow-right.jinriswiperRight {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  bottom: 0;
  left: 30%;
  margin-bottom: -13px;
  transform: rotate(90deg);
  right: 0;
  background: url("~@/assets/images/product_detail/recommend_arrow_right.png")
    no-repeat center;
  cursor: pointer;
}
.jinriswiperDown .arrow-left.jinriswiperDown {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  left: 0;
  background: url("~@/assets/images/product_detail/recommend_arrow_left.png")
    no-repeat center;
  cursor: pointer;
}
.jinriswiperDown .arrow-right.jinriswiperDown {
  z-index: 9;
  width: 22px;
  height: 48px;
  position: absolute;
  top: 50%;
  margin-top: -24px;
  right: 0;
  background: url("~@/assets/images/product_detail/outreach_more.png")
    no-repeat center;
  cursor: pointer;
}
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}
.mainTitle{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  font-size: 16px;
  font-weight: 800;
  color: #333;
  text-align: center;
}
</style>
<style>
.swipers img {
  object-fit: contain !important;
}
</style>



// WEBPACK FOOTER //
// src/components/flowDetail/jinrizixunSwipers.vue